import { Button, Typography } from 'antd';
import React, { ReactElement } from 'react';
import Layout from './Layout';

export default function ApplicationsSolicitorsAccountantsReport(): ReactElement {
    return (
        <Layout section='applications-solicitors-accountants'>
            <Typography.Title level={2}>Applications Solicitiors and Accountants</Typography.Title>
            <Button
                href={`${process.env.API_HOST}/applications/download-solicitors-accountants-report`}
                target='_blank'
                type='primary'
            >Download</Button>
        </Layout>
    );
}
